import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import "./style.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Navbar from "../../Components/Navbar";
import TeamImage1 from "../../Assets/images/team-38.png";
import TeamImage2 from "../../Assets/images/FINAL ID CARDS-45.png";
import TeamImage3 from "../../Assets/images/team-43.png";
import { useParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks";
import { getOrgProjectDetails } from "../../api/project/getOrgProjectDetails";
import { getUserGoalByProject } from "../../api/UserPerformance/getuserGoalByProject";
import { getMemberProjectGoal } from "../../api/ProjectLeadPerformance/getMemberProjectGoal";
import ProjectDetails from "../../Components/ProjectDetailCard";
import ProjectMemberCard from "../../Components/ProjectMemeberCard";
import parse from "html-react-parser";
import ViewProjectSc from "./view.sc";
function Tabs() {
  const [toggleState, setToggleState] = useState(1);
  const [orgProject, setOrgProject] = useState<any>([]);
  const [userGoal, setUserGoal] = useState<any>([]);
  const [projectMemberGoal, setProjectMemberGoal] = useState<any>([]);
  const [goaluser, setGoalUser] = useState<any>([]);
  const params = useParams();
  const navigate = useNavigate();
  const auth = useAuthContext();
  const fetchOrgProjectDetails = async () => {
    // if (!params?.viewProjectId) return;
    setOrgProject(
      await getOrgProjectDetails(
        auth?.userInfo?.orgs[0]?.id,
        params?.viewProjectId
      )
    );
    console.log("works");
  };
  const fetchOrgUserProjectGoals = async () => {
    // if (!params?.viewProjectId) return;
    setUserGoal(
      await getUserGoalByProject(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        params?.viewProjectId
      )
    );
    console.log("works goals");
  };
  const fetchGoalOfMemberAsProjectLead = async () => {
    if (!params?.viewProjectId) return;
    setProjectMemberGoal(
      await getMemberProjectGoal(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        params?.viewProjectId
      )
    );
    console.log("new works member Goal");
  };
  const handleCreate = async (e: any) => {
    console.log("data >", e);
  };
  const onSubmit = async (e: any) => {
    console.log("i m here", e);
    handleCreate(e);
  };
  console.log("org project", orgProject);
  console.log("user Goal", userGoal);
  console.log("i am here", params?.viewProjectId);
  console.log("Member Goal", projectMemberGoal);

  useEffect(() => {
    fetchOrgProjectDetails();
    fetchOrgUserProjectGoals();
    fetchGoalOfMemberAsProjectLead();
  }, []);

  const [person, setPerson] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [buttonChange, setButtonChange] = useState("button1");
  const unSelectedClass = "";
  const selectedClass = "selected-profile";

  function toggleTab(index: any) {
    setToggleState(index);
  }

  return (
    <ViewProjectSc>
      <div className="container">
        <div className="bloc-tabs">
          <button
            className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
            onClick={() => toggleTab(1)}
          >
            <h6>Projects</h6>
          </button>
          <button
            className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
            onClick={() => toggleTab(2)}
          >
            <h6>Goals</h6>
          </button>
        </div>

        <div className="content-tabs-project">
          <div
            className={
              toggleState === 1 ? "content  active-content" : "content"
            }
          >
            {orgProject &&
              orgProject?.map((data: any) => {
                return (
                  <>
                    <div>
                      <ProjectDetails
                        ProjectName={data?.project}
                        description={data?.description}
                      />
                    </div>
                    <div>
                      <div className="individual-member-container">
                        {data &&
                          data?.Members?.map((data: any) => {
                            return (
                              <>
                                <ProjectMemberCard
                                  memberName={data?.fname + " " + data?.lname}
                                  roleName={data?.role}
                                />
                              </>
                            );
                          })}
                      </div>
                    </div>
                  </>
                );
              })}
          </div>

          <div
            className={
              toggleState === 2 ? "content  active-content" : "content"
            }
          >
            <>
              <h4>My Project Goals</h4>
              <div className="individual-view">
                {userGoal &&
                  userGoal?.map((zero: any) => {
                    return (
                      <>
                        <div>{zero?.name}</div>
                      </>
                    );
                  })}
                <Button variant="primary" onClick={handleShow}>
                  View My Goal
                </Button>
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>My Project Goal</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {userGoal &&
                      userGoal?.map((zero: any) => {
                        return (
                          <>
                            <div>Name:{zero?.name}</div>
                            {zero?.goals?.map((goal: any) => {
                              return (
                                <>
                                  <div>
                                    <div>Project Name:{goal?.ProjectName}</div>
                                    <div>Due Date:{goal?.DueDate}</div>
                                    <div>Goals:{parse(goal?.Goals)}</div>
                                  </div>
                                </>
                              );
                            })}
                          </>
                        );
                      })}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>

              <div className="goals-main-container">
                <div className="data-part">
                  {projectMemberGoal && projectMemberGoal.length > 0 ? (
                    <h4>My Team goals</h4>
                  ) : null}

                  {projectMemberGoal &&
                    projectMemberGoal?.map((data: any, Id: any) => {
                      return (
                        <div
                          id="button1"
                          className={`performance-container
                  ${
                    buttonChange == "button1" ? selectedClass : unSelectedClass
                  } `}
                          onClick={() => {
                            setPerson("Person1");
                            setButtonChange("button1");
                          }}
                        >
                          <div>Goal Id:{data?.goal_id}</div>
                          <div>{data?.Name}</div>
                          <div>{data?.project_name}</div>
                          <Button
                            variant="primary"
                            onClick={() =>
                              navigate(`projectMember/${data.org_user_id}`)
                            }
                          >
                            View Details
                          </Button>
                        </div>
                      );
                    })}
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </ViewProjectSc>
  );
}

export default Tabs;
